import {
  Droplets, Zap, Brain, Shield, Sparkles, Heart, Activity,
  Flame, Sun, Pill, Plane, Leaf, AlertCircle, Star, Moon, Wand2
} from "lucide-react";

export const POPULAR_SERVICES = [
  { name: "Mobile IV Therapy", icon: Droplets, slug: "mobile-iv-therapy" },
  { name: "Hydration Therapy", icon: Droplets, slug: "hydration-therapy" },
  { name: "NAD+ Therapy", icon: Brain, slug: "nad-therapy" },
  { name: "Myers Cocktail", icon: Sparkles, slug: "myers-cocktail" },
  { name: "Immune Boost", icon: Shield, slug: "immune-boost" },
  { name: "Vitamin C Infusion", icon: Sun, slug: "vitamin-c" },
  { name: "Athletic Recovery", icon: Activity, slug: "athletic-recovery" },
  { name: "Hangover Recovery", icon: Flame, slug: "hangover-recovery" },
  { name: "Beauty & Glow Drips", icon: Star, slug: "beauty-glow" },
  { name: "Weight Loss IV", icon: Zap, slug: "weight-loss-iv" },
  { name: "Iron Infusions", icon: Pill, slug: "iron-infusions" },
  { name: "Glutathione Therapy", icon: Leaf, slug: "glutathione" },
  { name: "Jet Lag Recovery", icon: Plane, slug: "jet-lag" },
  { name: "Detox Therapy", icon: Heart, slug: "detox-therapy" },
  { name: "Migraine Relief", icon: AlertCircle, slug: "migraine-relief" },
  { name: "Anti-Aging Therapy", icon: Wand2, slug: "anti-aging" },
];

// Phase 3: services grouped by category (informed by competitor research)
export const SERVICE_CATEGORIES = [
  { key: "energy", label: "Energy & Performance", services: ["NAD+ Infusion", "Myers Cocktail", "Energy & Focus IV", "Performance Plus IV", "Vitamin B Complex IV", "B12 Injection"] },
  { key: "recovery", label: "Recovery", services: ["Athletic Recovery", "Recovery IV", "Hangover Recovery", "Food Poisoning IV", "Jet Lag Recovery"] },
  { key: "immunity", label: "Immunity & Wellness", services: ["Immune Boost IV", "Cold & Flu IV", "Vitamin C Megadose", "Hydration Drip"] },
  { key: "beauty", label: "Beauty & Anti-Aging", services: ["Beauty & Glow Drip", "Glutathione Therapy", "Anti-Aging IV", "Wedding Glow Drip"] },
  { key: "weight", label: "Weight & Metabolism", services: ["Weight Loss IV", "Detox Therapy"] },
  { key: "specialty", label: "Specialty & Symptom Relief", services: ["Migraine Relief IV", "Magnesium IV", "Iron Infusion", "Stress & Serenity IV", "Period Relief IV", "Morning Sickness IV", "Sunburn Recovery IV"] },
];

export const SERVICE_LIBRARY = [
  "Myers Cocktail", "NAD+ Infusion", "Hydration Drip", "Immune Boost IV",
  "Hangover Recovery", "Beauty & Glow Drip", "Vitamin C Megadose",
  "Athletic Recovery", "Weight Loss IV", "Glutathione Therapy",
  "B12 Injection", "Migraine Relief IV", "Iron Infusion", "Jet Lag Recovery",
  "Detox Therapy", "Anti-Aging IV",
  // Phase 3 additions
  "Cold & Flu IV", "Food Poisoning IV", "Sunburn Recovery IV",
  "Energy & Focus IV", "Vitamin B Complex IV", "Magnesium IV",
  "Morning Sickness IV", "Period Relief IV", "Stress & Serenity IV",
  "Performance Plus IV", "Recovery IV", "Wedding Glow Drip",
];

export const HERO_IMAGE = "https://images.unsplash.com/photo-1612277795421-9bc7706a4a34?auto=format&fit=crop&w=2400&q=80";
export const SECONDARY_IMAGE = "https://static.prod-images.emergentagent.com/jobs/9ee4a766-8f4b-43e0-a37a-c07e9998c3a3/images/1f54c8b5e9be6338d339d5f7053e6a9571619e8e61522e013934cefcec2fb769.png";

export const TOP_CITIES = [
  { city: "Los Angeles", state: "California", lat: 34.0522, lng: -118.2437 },
  { city: "Miami", state: "Florida", lat: 25.7617, lng: -80.1918 },
  { city: "New York", state: "New York", lat: 40.7128, lng: -74.006 },
  { city: "Phoenix", state: "Arizona", lat: 33.4484, lng: -112.074 },
  { city: "Houston", state: "Texas", lat: 29.7604, lng: -95.3698 },
  { city: "Las Vegas", state: "Nevada", lat: 36.1699, lng: -115.1398 },
  { city: "Chicago", state: "Illinois", lat: 41.8781, lng: -87.6298 },
  { city: "Dallas", state: "Texas", lat: 32.7767, lng: -96.797 },
  { city: "Denver", state: "Colorado", lat: 39.7392, lng: -104.9903 },
  { city: "Atlanta", state: "Georgia", lat: 33.749, lng: -84.388 },
];

export const DAY_LABELS = [
  { key: "mon", label: "Monday" },
  { key: "tue", label: "Tuesday" },
  { key: "wed", label: "Wednesday" },
  { key: "thu", label: "Thursday" },
  { key: "fri", label: "Friday" },
  { key: "sat", label: "Saturday" },
  { key: "sun", label: "Sunday" },
];

export const TRUST_BADGES = [
  { key: "verified", label: "Verified Business", icon: "BadgeCheck" },
  { key: "licensed_nurses", label: "Licensed Medical Staff", icon: "Stethoscope" },
  { key: "medical_director", label: "Medical Director on Staff", icon: "UserCog" },
  { key: "hipaa", label: "HIPAA Compliant", icon: "Lock" },
  { key: "background", label: "Background Checked", icon: "Shield" },
  { key: "top_rated", label: "Top Rated", icon: "Trophy" },
  { key: "same_day", label: "Same-Day Available", icon: "Zap" },
  { key: "evening", label: "Evening & Weekend", icon: "Moon" },
];
